import React, { Component } from 'react';
import config from '../config';
import axios from 'axios'
import loader from '../images/ajax-loader.gif'
import { withRouter } from 'react-router-dom';
import { FixedSizeList as List } from "react-window";

import Select from 'react-select';

// Be sure to include styles at some point, probably during your bootstrapping
// import '../../node_modules/react-select/dist/css/react-select.css';
const height = 35;

class Quote extends Component {
    constructor(props) {
        super(props)

        this.state = {
            productList: [],
            productListLoader: true,
            selectedProduct: "",
            selectedProductName: "",
            selectedProductErr: "",
            selectedProductPricingData: [],
            selectedProductPricingLoader: false,
            productQuantityInputValue: "",
            productQuantityInputErr: "",
            quantityPrice: 0,
            totalProductPrice: 0,
            selectedPriceBracket: "",
            currencyList:[{value:"USD", label:"USD"},{value:"CAD",label:"CAD"}],
            selectedCurrency:"USD"
        }
        // this.getProductPricing = this.getProductPricing.bind(this);
    }

    componentDidMount() {
        var page = this;

        // Get all products
        this.getAllProducts();
    }

    componentDidUpdate() { }

    getAllProducts() {
        var page = this;
        var data = new FormData();
        const formConfig = {
            method: 'get',
            url: config.PCNA_SERVICE_URL + "CRUD/getAllProductCode",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        axios(formConfig)
            .then(function (response) {
                if (response.data.errorMsg == "") {
                    //var productData = response.data.getProductDateModifiedResponse.productDateModifiedArray;
                    // var productData = response.data.productSellableArray;
                    var productData = response.data.lstProductIDwithPartID;
                   // debugger
                    if (productData.length > 0) {
                        page.setState({
                            productList: productData
                        }, () => {
                            page.setState({ productListLoader: false, selectedProductErr: "", productListLoader: false });  // loader functionality
                        });
                    }
                }
                else {
                    page.setState({ selectedProductErr: response.data.errorMsg, productListLoader: false })
                }

            })
            .catch((error) => {
                // Show Error while fetching data
                page.setState({ productListLoader: false });
            });
    }

    getProductPricing(e) {
        var page = this;
        // var selectedProduct = e.target.value;
        var selectedProduct = e.value;
        document.getElementById("quantityField").removeAttribute("disabled");

        page.setState({ selectedProductPricingLoader: true, selectedProduct: selectedProduct, selectedProductErr: "" });
       // var selectedProductArr = selectedProduct.split("~");
        var data = new FormData();
        const formConfig = {
            method: 'get',
            url: config.PCNA_SERVICE_URL + "CRUD/getpricingItemCode?ItemCode=" + selectedProduct, //+ "&partId=" + selectedProductArr[1],
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        axios(formConfig)
            .then(function (response) {
                // var productPricingData = response.data.lstPriceArray;
                var productName = response.data.productDetails.productName != "" ? response.data.productDetails.productName+"("+response.data.productDetails.productId+")" : response.data.productDetails.productId;
                var productPricingArr = response.data.productDetails.productPriceGroupArray;

                var productPricingArrFiltered = productPricingArr.filter(function(row,index){
                    if((page.state.selectedCurrency=="USD" && row.groupName == "USD-Net-Decorated")||
                    (page.state.selectedCurrency=="CAD" && row.groupName == "CAD-Net-Decorated")
                    )
                    {
                       // debugger
                        return row;
                    }
                })
                // var productPricingData = response.data.productDetails.productProcingArr[0].priceArray;
                var productPricingData = productPricingArrFiltered[0].priceArray;

                if (productPricingData.length > 0) {
                    page.setState({
                        selectedProductPricingData: productPricingData
                    }, () => {
                        page.setState({ selectedProductPricingLoader: false, selectedProductErr: "", selectedProductName: productName });  // loader functionality
                        page.checkRefreshedProductPrice();
                    });
                }
                else {
                    page.setState({ selectedProductErr: response.data.errorMsg, selectedProductPricingLoader: false, selectedProductName: "" });
                    document.getElementById("quantityField").setAttribute("disabled", "disabled");
                }
            })
            .catch((error) => {
                // Show Error while fetching data
                page.setState({ selectedProductPricingLoader: false });
            });

    }

    selectCurrency(e){
       // debugger
        var page = this;
        page.setState({selectedCurrency:e.value})


    }
    
    checkProductPrice(e) {
        var page = this;
        var productQuantity = e.target.value;

        if (/^\d*$/.test(productQuantity)) {
            page.setState({
                productQuantityInputValue: e.target.value,
                productQuantityInputErr: ""
            }, () => {
                //Get price based on quantity
                var selectedProductPricingData = page.state.selectedProductPricingData;
                var quantityPrice = 0;
                var selectedPriceBracket = "";
                if (selectedProductPricingData.length > 0) {
                    if (selectedProductPricingData[0].minQuantity >= productQuantity) {
                        quantityPrice = selectedProductPricingData[0].price;
                        selectedPriceBracket = 0;
                    }
                    else if (selectedProductPricingData[selectedProductPricingData.length - 1].minQuantity <= productQuantity) {
                        quantityPrice = selectedProductPricingData[selectedProductPricingData.length - 1].price;
                        selectedPriceBracket = selectedProductPricingData.length - 1;
                    }
                    else {
                        for (var i = 0; i < selectedProductPricingData.length; i++) {
                            if (selectedProductPricingData[i].minQuantity <= productQuantity && selectedProductPricingData[i + 1].minQuantity > productQuantity) {
                                quantityPrice = selectedProductPricingData[i].price;
                                selectedPriceBracket = i + 1;
                            }
                        }
                    }

                    var totalNetProductPrice=0;
                    if(quantityPrice>=0.1){
                        totalNetProductPrice=(quantityPrice/0.6).toFixed(2) * productQuantity
                    }
//debugger
                    page.setState({ quantityPrice: quantityPrice, totalProductPrice: totalNetProductPrice, selectedPriceBracket: selectedPriceBracket });
                }
            });
        }
        else {
            page.setState({ productQuantityInputValue: e.target.value, productQuantityInputErr: "Please enter valid quantity" });
        }
    }

    checkRefreshedProductPrice() {
        var page = this;
        var productQuantity = document.getElementById("quantityField").value;

        if (/^\d*$/.test(productQuantity)) {
            page.setState({
                productQuantityInputValue: document.getElementById("quantityField").value,
                productQuantityInputErr: ""
            }, () => {
                //Get price based on quantity
                var selectedProductPricingData = page.state.selectedProductPricingData;
                var quantityPrice = 0;
                var selectedPriceBracket = "";
                if (selectedProductPricingData.length > 0) {
                    if (selectedProductPricingData[0].minQuantity >= productQuantity) {
                        quantityPrice = selectedProductPricingData[0].price;
                        selectedPriceBracket = 0;
                    }
                    else if (selectedProductPricingData[selectedProductPricingData.length - 1].minQuantity <= productQuantity) {
                        quantityPrice = selectedProductPricingData[selectedProductPricingData.length - 1].price;
                        selectedPriceBracket = selectedProductPricingData.length - 1;
                    }
                    else {
                        for (var i = 0; i < selectedProductPricingData.length; i++) {
                            if (selectedProductPricingData[i].minQuantity <= productQuantity && selectedProductPricingData[i + 1].minQuantity > productQuantity) {
                                quantityPrice = selectedProductPricingData[i].price;
                                selectedPriceBracket = i + 1;
                            }
                        }
                    }

                    var totalNetProductPrice=0;
                    if(quantityPrice>=0.1){
                        totalNetProductPrice=(quantityPrice/0.6).toFixed(2) * productQuantity
                    }

                    page.setState({ quantityPrice: quantityPrice, totalProductPrice: totalNetProductPrice, selectedPriceBracket: selectedPriceBracket });
                }
            });
        }
        else {
            page.setState({ productQuantityInputValue: productQuantity, productQuantityInputErr: "Please enter valid quantity" });
        }
    }

    render() {
        var page = this;

        return (
            <div className="d-flex flex-column-fluid">
                <div className="container">
                    <div className="card card-custom overflow-hidden">
                        <div className="card-body p-0">
                            <div className="row justify-content-center px-8 py-md-10 px-md-0">
                                <div className="col-md-9">
                                    <div className="d-flex justify-content-between pb-md-10 flex-column flex-md-row">
                                        <h1 className="display-4 font-weight-boldest">Quote Generation</h1>
                                    </div>
                                    <div className="border-bottom w-100"></div>
                                    {
                                        page.state.selectedProductErr != "" ?
                                            <div class="alert alert-danger" role="alert">
                                                {page.state.selectedProductErr}
                                            </div>
                                    : ""}
                                    <div className="d-flex justify-content-between pt-6">
                                        <div className="d-flex flex-column flex-root">
                                            <span className="font-weight-bolder mb-2 mt-2 text-left">CURRENCY</span>
                                            <Select id="currency_select"
                                               name="form-field-currency"
                                                value={this.value}
                                              // value={page.state.selectedCurrency}
                                                options={page.state.currencyList}
                                                onChange={page.selectCurrency.bind(this)}
                                               // components={{ MenuList }}
                                                className="text-left"
                                                placeholder="Select a currency"
                                            />
                                        </div>
                                    </div>
                                    
                                    <div className="d-flex justify-content-between pt-6">
                                        <div className="d-flex flex-column flex-root">
                                            <span className="font-weight-bolder mb-2 mt-2 text-left">PRODUCT  {page.state.productListLoader == true ? <img className="mt-2 text-left" src={loader} style={{ 'width': '20px',float: 'right' }} /> : ""}</span>
                                            <Select
                                                id="test_select"
                                                name="form-field-name"
                                                value={this.value}
                                                options={page.state.productList}
                                                onChange={page.getProductPricing.bind(this)}
                                                components={{ MenuList }}
                                                className="text-left"
                                                placeholder="Select a product"
                                            />
                                        </div>
                                    </div>
                                    
                                    
                                    {/* <div className="d-flex justify-content-between pt-6">
                                        <div className="d-flex flex-column flex-root">
                                            <span className="font-weight-bolder mb-2 mt-2 text-left">PRODUCT</span>
                                            <select className="form-control" onChange={(event) => page.getProductPricing(event)} >
                                                <option value="">Select Product</option>
                                                {
                                                    this.state.productList.map(function (product) {
                                                        return (
                                                            <option value={product.productId + "~" + product.partId}>{product.productId + " / Part id = " + product.partId}</option>
                                                        )
                                                    })
                                                }
                                                {/* <optgroup label="Category 1" data-select2-id="306">
                                                    <option value="AK" data-select2-id="307">Product Code XYZ 1 - Product 1</option>
                                                    <option value="HI" data-select2-id="308">Product Code XYZ 2 - Product 2</option>
                                                </optgroup> 

                                            </select>
                                            {page.state.productListLoader == true ? <img className="mt-2 text-left" src={loader} style={{ 'width': '20px' }} /> : ""}
                                        </div>
                                    </div> */}
                                    <div className="d-flex justify-content-between pt-6">
                                        <div className="d-flex flex-column flex-root">
                                            {/* <div className="form-group form-group-last">

                                            </div> */}
                                            <span className="font-weight-bolder mb-2 mt-2 text-left">QUANTITY  {page.state.selectedProductPricingLoader == true ? <img className="mt-2 text-left" src={loader} style={{ 'width': '20px', float: 'right' }} /> : ""}</span>
                                            <div className="form-group">
                                                <input id="quantityField" type="text" className="form-control form-control-lg" placeholder="Quantity Required" onChange={(event) => page.checkProductPrice(event)} value={page.state.productQuantityInputValue}></input>
                                            </div>
                                            <span className="text-left" style={{ color: 'red' }}>{page.state.productQuantityInputErr}</span>
                                        </div>
                                    </div>
                                    <div className="alert alert-custom alert-default mt-5" role="alert">
                                        <div className="alert-icon">
                                            <span className="svg-icon svg-icon-primary svg-icon-xl">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <rect x="0" y="0" width="24" height="24"></rect>
                                                        <path d="M7.07744993,12.3040451 C7.72444571,13.0716094 8.54044565,13.6920474 9.46808594,14.1079953 L5,23 L4.5,18 L7.07744993,12.3040451 Z M14.5865511,14.2597864 C15.5319561,13.9019016 16.375416,13.3366121 17.0614026,12.6194459 L19.5,18 L19,23 L14.5865511,14.2597864 Z M12,3.55271368e-14 C12.8284271,3.53749572e-14 13.5,0.671572875 13.5,1.5 L13.5,4 L10.5,4 L10.5,1.5 C10.5,0.671572875 11.1715729,3.56793164e-14 12,3.55271368e-14 Z" fill="#000000" opacity="0.3"></path>
                                                        <path d="M12,10 C13.1045695,10 14,9.1045695 14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 C10,9.1045695 10.8954305,10 12,10 Z M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z" fill="#000000" fill-rule="nonzero"></path>
                                                    </g>
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="alert-text">Once the
											<code>product (code)</code> and the required
											<code>quantity</code> are selected, the system will fetch the product pricing.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue > 0 ?

                                    <div className="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="font-weight-bold text-muted text-uppercase">Product</th>
                                                    <th className="font-weight-bold text-muted text-uppercase">Quantity</th>
                                                    {/* <th className="font-weight-bold text-muted text-uppercase">Selected Bracket (Column)</th> */}
                                                    {/* <th className="font-weight-bold text-muted text-uppercase">Price</th> */}
                                                    <th className="font-weight-bold text-muted text-uppercase">Net Price</th>
                                                    <th className="font-weight-bold text-muted text-uppercase">Coded Price</th>
                                                    <th className="font-weight-bold text-muted text-uppercase">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="font-weight-bolder">
                                                    <td>{page.state.selectedProductName}</td>
                                                    <td>{page.state.productQuantityInputValue}</td>
                                                    {/* <td>{page.state.selectedPriceBracket}</td> */}
                                                    <td>${(page.state.quantityPrice/0.6).toFixed(2)}</td>
                                                    <td>${page.state.quantityPrice}</td>
                                                    <td className="text-danger font-size-h3 font-weight-boldest">${page.state.totalProductPrice.toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    : ""
                            }
                            {/* <div className="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                                <div className="col-md-9">
                                    <div className="d-flex justify-content-between">
                                        <button type="button" className="btn btn-light-primary font-weight-bold" onclick="window.print();">Download Quote</button>
                                        <button type="button" className="btn btn-primary font-weight-bold" onclick="window.print();">Save Quote</button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}


// To fix slowness of react-select when dataset is too large
class MenuList extends Component {
    render() {
      const { options, children, maxHeight, getValue } = this.props;
      const [value] = getValue();
      const initialOffset = options.indexOf(value) * height;
  
      return (
        <List
          height={maxHeight}
          itemCount={children.length}
          itemSize={height}
          initialScrollOffset={initialOffset}
        >
          {({ index, style }) => <div style={style}>{children[index]}</div>}
        </List>
      );
    }
  }


export default withRouter(Quote);